import { useCallback } from 'react'

import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import { useIsOffline } from '@liveHelper/hooks/useIsOffline'
import {
  actionsSelector,
  useStore,
  visibilityRulesMatchSelector,
  waitlistCapacityReachedSelector,
} from '@liveHelper/models/store'

/**
 * Hook that shows the widget at any time after the channel join.
 */
export const useShowWidgetAfterChannelJoin = () => {
  const { showWidget } = useStore(actionsSelector)

  const visibilityRulesMatch = useStore(visibilityRulesMatchSelector)
  const waitlistCapacityReached = useStore(waitlistCapacityReachedSelector)

  const chatChannelConfig = useChatChannelConfig()
  const isOffline = useIsOffline()

  const showWidgetAfterChannelJoin = useCallback(() => {
    if (!visibilityRulesMatch) {
      return
    }

    if (chatChannelConfig?.config?.widget_availability === 'never') {
      return
    }

    if (isOffline || waitlistCapacityReached) {
      return
    }

    showWidget()
  }, [
    chatChannelConfig,
    isOffline,
    showWidget,
    visibilityRulesMatch,
    waitlistCapacityReached,
  ])

  return showWidgetAfterChannelJoin
}
